import dateFormat from "dateformat";

export function formatContentTime(datetime) {
    return dateFormat(datetime, "mmmm dS, yyyy, h:MM TT Z");
}

export function formatDatetimeToISO(datetime) {
    return dateFormat(datetime, "UTC:yyyy-mm-dd'T'HH:MM:ss");
}

const DAYS = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
];
const MONTHS = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
];

function padNumber(number) {
    return number < 10 ? `0${number}` : number.toString();
}

export function formatDate(dateTime) {
    return `${DAYS[dateTime.getDay()]}, ${
        MONTHS[dateTime.getMonth()]
    } ${dateTime.getDate()}, ${dateTime.getFullYear()}`;
}

export function formatShowDisplayTime(dateTime) {
    return `${padNumber(dateTime.getHours())}:${padNumber(
        dateTime.getMinutes()
    )}`;
}
